module.exports = __webpack_public_path__ + "img/eg-1.981e48d2.jpg";